import React, { createContext, useState, useContext, ReactNode } from 'react';
import { Snackbar, Alert } from '@mui/material';

interface SnackbarContextData {
    exibirMensagem: (mensagem: string, tipo: 'success' | 'error' | 'warning' | 'info') => void;
}

interface SnackbarProviderProps {
    children: ReactNode;
}

const SnackbarContext = createContext<SnackbarContextData | undefined>(undefined);

export const SnackbarProvider: React.FC<SnackbarProviderProps> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [tipo, setTipo] = useState<'success' | 'error' | 'warning' | 'info'>('info');

    const exibirMensagem = (mensagem: string, tipo: 'success' | 'error' | 'warning' | 'info') => {
        setMensagem(mensagem);
        setTipo(tipo);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <SnackbarContext.Provider value={{ exibirMensagem }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Exibe no topo central
            >
                <Alert onClose={handleClose} severity={tipo} sx={{ width: '100%' }}>
                    {mensagem}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar deve ser usado dentro de um SnackbarProvider');
    }
    return context;
};